<template>
  <div class="d-flex justify-content-center align-items-center">
    <b-card class="text-center mt-5">
      <h5 class="mb-3">{{ $t('security.sendCredentialLinkTitle') }}</h5>
      <b-button class="mb-3" variant="success" @click="setPayloadValues">
        {{ $t('security.sendCredentialLinkBtn') }}
      </b-button>
      <b-alert v-show="successfullSendCredentialLink" fade show variant="success">
        <small>{{ $t('security.SendCredentialLinkSuccessfullMsg') }}</small>
      </b-alert>
    </b-card>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'SendCredentialLink',
  data(){
    return {
       successfullSendCredentialLink: false
    }
  },
  computed: {
    ...mapGetters({
       designConfig: 'tenantDesign/config',
       userSubscriptions: 'subscription/userSubscriptions'
    })
  },
  methods:{
    ...mapActions({
       alreadySub: 'subscription/alreadySub',
       getUserStatus: 'subscription/getUserStatus',
    }),
    setPayloadValues(){
      this.isLoading = true
      var username = null
      var ppc= null
      if(this.$route.query.userName){
        username = this.$route.query.userName
        let statusPayload = {
          username : username
        }
        this.getUserStatus(statusPayload)
          .then(statusResponse => {
            ppc = statusResponse.body.result[0].planProviderCode
            this.alreadySubRequest(username,ppc)
          })
      } else if (this.$route.query.alreadysubUserName) {
        username = this.$route.query.alreadysubUserName
        let statusPayload = {
          username : username
        }
        this.getUserStatus(statusPayload)
          .then(statusResponse => {
            ppc = statusResponse.body.result[0].planProviderCode
            this.alreadySubRequest(username,ppc)
          })
      } else{
         username = this.userSubscriptions[0].userName
         ppc = this.userSubscriptions[0].planProviderCode
         this.alreadySubRequest(username,ppc)
      }
    },
    alreadySubRequest(username,planProviderCode){
      let payload = {
        planProviderCode: planProviderCode,
        userName: username,
        channel: 'Portal',
        channelName: window.location.hostname
      }
      this.alreadySub(payload).then(response => {
        let result = response.body.result
        this.successfullSendCredentialLink = true
      })

    }
  }
}
</script>
